import React from 'react';
import { Card, Row, Col, Button, Spinner } from 'react-bootstrap';

const ConfigButtons = ({ loading, onUpdate, onSetting, disabled = false, sts }) => {
  return (
    <Card className="mb-3" style={{ background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
      <Card.Body className="py-3 px-4">
        <Row className="align-items-center">
          <Col xs={12} md={7} className="text-white mb-2 mb-md-0">
            <div style={{ fontSize: '0.95rem', fontWeight: 500 }}>
              <span style={{ fontSize: '1.3rem', marginRight: 8 }}>⚙️</span>
              Carregue as configurações e calibrações atuais do equipamento
            </div>
            <div style={{ fontSize: '0.75rem', opacity: 0.9, marginTop: 4 }}>
              Os valores serão exibidos nos botões de comando
            </div>
          </Col>
          <Col xs={12} md={5} className="text-md-end">
            <div className="d-flex gap-2 flex-column flex-md-row">
              <Button
                variant="warning"
                onClick={onSetting}
                disabled={loading || sts === 0}
                style={{
                  fontWeight: 600,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                  border: 'none',
                  flex: 1
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Enviando...
                  </>
                ) : (
                  <>
                    Liberar configuração
                  </>
                )}
              </Button>
              <Button
                variant="light"
                onClick={onUpdate}
                disabled={loading || disabled}
                style={{
                  fontWeight: 600,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                  border: 'none',
                  flex: 1
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Atualizando...
                  </>
                ) : (
                  <>
                    Atualizar
                  </>
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ConfigButtons;
